module.exports = __webpack_public_path__ + "@/assets/img/face-id.1e2d43db.svg";